const SETTINGS_PAGE_MUTUAL = {
  // Menu
  MENU_GENERAL_SETTINGS: 'تنظیمات عمومی',
  BASE_SETTINGS: 'تنظیمات پایه',
  MENU_WIDGET_CUSTOMIZE: 'شخصی سازی ابزارک',
  MENU_OFFICE_HOURS: 'زمان های کاری',
  MENU_EMAIL: 'ایمیل‌ها',
  MENU_AUTO_MSG: 'هوشمندسازی',
  MENU_RESPONSE_DELAY: 'حالت انتظار',
  WIDGET_FORM_FORCE_OPTION: 'اجباری بودن دریافت اطلاعات',
  WIDGET_FORM_BEFORE_FIRST_MSG: 'ارسال فرم قبل از ارسال اولین پیام',
  MENU_FORM_GENERATOR: 'ایجاد فرم',
  MENU_RESPONSIVE_ROBOT: 'ربات پاسخگو',

  // Offline form
  WIDGET_FORM_OPTIONS_EMAIL: 'دریافت ایمیل',
  WIDGET_FORM_OPTIONS_PHONE: 'دریافت شماره تماس',
  WIDGET_FORM_OPTIONS_EMAIL_PHONE: 'دریافت ایمیل و شماره تماس',
  WIDGET_FORM_OPTIONS_NAME_PHONE: 'دریافت نام و شماره تماس',
  WIDGET_FORM_OPTIONS_NAME_PHONE_EMAIL: 'دریافت نام، ایمیل و شماره تماس',
  WIDGET_FORM_TAB_FORM: 'دریافت فرم',
  WIDGET_FORM_TAB_MSG: 'ارسال پیام',
  WIDGET_FORM_SEND_MSG_OPTION:
    'پیامی که به همراه دریافت اطلاعات کاربر ارسال میشود',

  // Save bar
  SAVE_BAR_SAVE_BTN: 'ذخیره',
  SAVE_BAR_CANCEL_BTN: 'انصراف',

  // Tooltip
  COMING_SOON: 'بزودی',

  // FORM GENERATOR
  FORM_GENERATOR_INPUT_TYPE_STRING: 'متن',
  FORM_GENERATOR_INPUT_TYPE_NUMBER: 'عدد',
  FORM_GENERATOR_INPUT_TYPE_PHONE: 'شماره تلفن',
  FORM_GENERATOR_INPUT_TYPE_EMAIL: 'ایمیل',
  FORM_GENERATOR_INPUT_TYPE_NAME: 'نام',
  FORM_GENERATOR_TITLE: 'ایجاد فرم',
  FORM_GENERATOR_FIELD_LABEL: 'فیلد شماره ',
  FORM_GENERATOR_LABEL: 'برچسب فیلد را مشخص کنید',
  FORM_GENERATOR_PLACEHOLDER: 'نام فیلد را وارد کنید!',
  FORM_GENERATOR_TYPE: 'نوع فیلد را مشخص کنید',
  FORM_GENERATOR_BUTTON: 'افزودن فرم',
  FORM_GENERATOR_ADD_BTN: 'اضافه کردن فیلد جدید',

  //
  FORM_SUBMIT: 'ثبت',
};

export default SETTINGS_PAGE_MUTUAL;
